import api from '../services/api';
import {mapContactDto} from "../dto/ContactDTO";


export const getAllContacts = async () => {
    try {
        const res = await api.get('/Contact');
        return res.data.map(mapContactDto);
    } catch (err) {
        console.error("Error receiving contacts:", err);
        throw err;
    }
};

export const addContact = async (contact) => {
    try {
        const res = await api.post(`/Contact`, contact);
        return res.data;
    } catch (err) {
        console.error("Error adding contact:", err);
        throw err;
    }
};

export const deleteContact = async (contactId) => {
    try {
        const res = await api.delete(`/Contact/${contactId}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting contact:", err);
        throw err;
    }
};

export const patchContact = async (contactId, data) => {
    try {
        const res = await api.patch(`/Contact/${contactId}`, data);
        return res.data;
    } catch (err) {
        console.error("Error updating contact:", err);
        throw err;
    }
};
